export default {
  "bulletinboard.head.title": "人と情報の交流掲示板一覧 | LINK-J",
  "bulletinboard.head.description":
    "LINK-J特別会員の最新ニュースを掲載しています。",
  "bulletinboard.list.head.siteName": "LINK-J",
  "bulletinboard.list.title": "人と情報の交流掲示板",
  "bulletinboard.list.eventDate": "開催日",
  "bulletinboard.list.deadline": "締切日",
  "bulletinboard.list.postDate": "投稿日",
  "bulletinboard.list.poster": "投稿者",
  "bulletinboard.list.termsNotice.text1":
    "この掲示板は、LINK-J特別会員およびLINK-Jと提携している団体との共有掲示板です。内容に関するお問合せ、掲載については",
  "bulletinboard.list.termsNotice.text2":
    "をご覧ください。掲示板の運営に関するお問合せは、LINK-J（contact@link-j.orgもしくは 03-3241-4911）までご連絡ください。",
  "bulletinboard.list.termsNotice.link": "こちら",

  "bulletinboard.detail.head.siteName": "人と情報の交流掲示板",
  "bulletinboard.detail.title": "人と情報の交流掲示板",
  "bulletinboard.detail.postDate": "投稿日",
  "bulletinboard.detail.poster": "投稿者",
  "bulletinboard.detail.eventDate": "開催日",
  "bulletinboard.detail.eventTime": "時間",
  "bulletinboard.detail.applicationPeriod": "募集期間",
  "bulletinboard.detail.venue": "会場",
  "bulletinboard.detail.detailsAndApplication": "詳細・参加申込",
  "bulletinboard.detail.externalSiteNote": "（外部サイトが開きます）",
  "bulletinboard.detail.referenceMaterials": "参考資料",
  "bulletinboard.detail.organizer": "主催",
  "bulletinboard.detail.contactInformation": "お問い合わせ先",

  "bulletinboard.categories.index": "掲示板一覧",
  "bulletinboard.categories.news": "ニュース・事業紹介",
  "bulletinboard.categories.bulletinboardsPressRelease": "会員プレスリリース",
  "bulletinboard.categories.bulletinboardsRecruit": "募集",
  "bulletinboard.categories.bulletinboardsEvent": "イベント",
} as const;
